"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const CenteredPage_1 = require("./CenteredPage");
exports.NotFoundPage = () => {
    return (react_1.default.createElement(CenteredPage_1.CenteredPage, { title: "Page not found", iconPreset: "compass", buttonText: "Go home", buttonTo: "/" }));
};
//# sourceMappingURL=NotFoundPage.js.map